export const STRINGS = {
    emptyMessage : 'Nenhum registro encontrado.'
}